export default [
  'MarketplaceService', 'CampaignService',
  class TrendingProductsCtrl {
    constructor (marketplaceService, campaignService) {
      this._campaignService = campaignService;
      this.loading = true;

      marketplaceService.productTypes()
        .then((res) => this._initProductTypes(res))
        .then(() => this._initAllTrendingTypes())
      ;
    }

    hasProducts (type) {
      return (Array.isArray(type.products) && type.products.length > 0);
    }

    _initProductTypes (res) {
      let productTypeArray = [];
      productTypeArray.push({
        id: null,
        name: 'ALL'
      });
      for (let key in res) {
        productTypeArray.push({
          id: key,
          name: res[key]
        });
      }
      this.types = productTypeArray;
    }

    _initAllTrendingTypes () {
      for (var i = 0; i < this.types.length; i++) {
        let type = this.types[i];
        this._campaignService.getTrending(4, type.id)
          .then((res) => {
            type.products = res;
            this.loading = false;
          });
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/trending-products/trending-products.ctrl.js